import { HorizontalContainer } from '@/components';
import { cn } from '@/lib/cn';

import { useLogger } from '../lib/log';

type TabNavigationProps = {
    tabs: Tab[];
    activeTab: string;
    setActiveTab: (tab: string) => void;
};

export type Tab = {
    key: string;
    label: string;
    count?: number;
};

export const TabNavigation = ({
    tabs,
    activeTab,
    setActiveTab,
}: TabNavigationProps) => {
    const log = useLogger();
    return (
        <HorizontalContainer spacing="none">
            {tabs.map((tab) => (
                <HorizontalContainer
                    spacing="xs"
                    key={tab.key}
                    className={cn('items-center justify-center px-4 py-2', {
                        'border-b-2 border-(--color-border-attention)':
                            activeTab === tab.key,
                        'cursor-pointer': activeTab !== tab.key,
                    })}
                    onClick={() => {
                        log(`Active tab: ${tab.key}`);
                        setActiveTab(tab.key);
                    }}
                >
                    <h4
                        className={cn('truncate', {
                            'font-normal': activeTab !== tab.key,
                        })}
                    >
                        {tab.label}
                    </h4>
                    {tab.count !== undefined && tab.count !== null && (
                        <span
                            className={cn('rounded px-1 text-center', {
                                'bg-(--color-bg-attention) text-(--color-text-attention)':
                                    activeTab === tab.key,
                                'bg-(--color-bg-subtle)': activeTab !== tab.key,
                            })}
                        >
                            {tab.count}
                        </span>
                    )}
                </HorizontalContainer>
            ))}
        </HorizontalContainer>
    );
};
